import { render, staticRenderFns } from "./DetailsInfoTable.vue?vue&type=template&id=71ec75cf&scoped=true&"
import script from "./DetailsInfoTable.vue?vue&type=script&lang=ts&"
export * from "./DetailsInfoTable.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsInfoTable.vue?vue&type=style&index=0&id=71ec75cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ec75cf",
  null
  
)

export default component.exports